/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const WarehouseCaseResponseDTOStatusEnum = {
    Open: 'OPEN',
    AwaitingCustomer: 'AWAITING_CUSTOMER',
    Resolved: 'RESOLVED',
    Closed: 'CLOSED'
};
/**
 * Check if a given object implements the WarehouseCaseResponseDTO interface.
 */
export function instanceOfWarehouseCaseResponseDTO(value) {
    return true;
}
export function WarehouseCaseResponseDTOFromJSON(json) {
    return WarehouseCaseResponseDTOFromJSONTyped(json, false);
}
export function WarehouseCaseResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'caseNumber': json['caseNumber'] == null ? undefined : json['caseNumber'],
        'title': json['title'] == null ? undefined : json['title'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'status': json['status'] == null ? undefined : json['status'],
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'lastMessageAt': json['lastMessageAt'] == null ? undefined : (new Date(json['lastMessageAt'])),
        'lastMessagePreview': json['lastMessagePreview'] == null ? undefined : json['lastMessagePreview'],
        'lastMessageAuthor': json['lastMessageAuthor'] == null ? undefined : json['lastMessageAuthor'],
        'unreadCount': json['unreadCount'] == null ? undefined : json['unreadCount'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'shippinglotOrderId': json['shippinglotOrderId'] == null ? undefined : json['shippinglotOrderId'],
        'awaitingReplyHours': json['awaitingReplyHours'] == null ? undefined : json['awaitingReplyHours'],
    };
}
export function WarehouseCaseResponseDTOToJSON(json) {
    return WarehouseCaseResponseDTOToJSONTyped(json, false);
}
export function WarehouseCaseResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'caseNumber': value['caseNumber'],
        'title': value['title'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'status': value['status'],
        'warehousePackageId': value['warehousePackageId'],
        'amazonOrderId': value['amazonOrderId'],
        'lastMessageAt': value['lastMessageAt'] == null ? undefined : ((value['lastMessageAt']).toISOString()),
        'lastMessagePreview': value['lastMessagePreview'],
        'lastMessageAuthor': value['lastMessageAuthor'],
        'unreadCount': value['unreadCount'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'marketplace': value['marketplace'],
        'shippinglotOrderId': value['shippinglotOrderId'],
        'awaitingReplyHours': value['awaitingReplyHours'],
    };
}
